import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const TopBar = styled.div`
  padding: 8px 40px;
  background-color: ${theme.colors.neutral.white};
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const Wrapper = styled.div`
  display: flex;
  gap: ${theme.spacing.xm};
  height: 100%;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${theme.spacing.xm};
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.xm};
  height: 100%;
`
export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing.xm};
`

export const Title = styled.h1`
  font-size: ${theme.typography.sizes.xm};
  color: ${theme.colors.neutral.black};
  font-weight: ${theme.typography.weight.lg};
  margin: 0;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  margin: ${theme.spacing.xm} 0;
`

export const Form = styled('form')`
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.md};
`

export const FieldsContainer = styled.div`
  display: grid;
  gap: ${theme.spacing.sm};
  margin-bottom: 16px;
  justify-content: left;
`

type FieldWrapperProps = {
  templateColumns: string
  mediaTemplateColumns?: string
}

export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: flex;

  flex-direction: column;
  gap: ${theme.spacing.sm} ${theme.spacing.md};
  width: 800px;
`

export const FieldItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextInfo = styled.h5`
  font-size: ${theme.typography.sizes['2xs']};
  color: ${theme.colors.neutral[50]};
  font-weight: ${theme.typography.weight.lg};
  margin: 0;
`
